import { CALL_API } from "../api.middleware";

export const getLot = (body) => async (dispatch) => {
  return await dispatch({
    [CALL_API]: {
      url: "/getlot",
      body,
      method: "POST",
      isReport: true,
    },
  });
};
export const createLot = (body) => async (dispatch) => {
  return await dispatch({
    [CALL_API]: {
      url: "/createlot",
      body,
      method: "POST",
      isReport: true,
    },
  });
};